import { ReactEventHandler } from "react";

export interface IIconProps {
  className?: string;
  size?: number;
  color?: string | string[];
  onClick?: ReactEventHandler;
}

export const ICON_DEFAULT_COLORS = {
  white: "#FFF",
  black: "#000",
  text: "#424242",
  primary: "#017AFD",
  info: "#2FB4DD",
  success: "#A3CE5E",
  danger: "#D23629",
  blue: "#307CD8",
  "blue-light": "#FDE1B8",
  "blue-dark": "#0B1C34",
  // tailwind.config.js `gray.b4`. Named here because this map is the only way a
  // palette value reaches an icon: `Icon` falls back to the raw string for an
  // unknown key, so `color="gray-b4"` would otherwise reach the SVG as
  // fill="gray-b4" and paint nothing.
  "gray-b4": "#B4B4B4",
  // tailwind.config.js `gray.70` and `orange.DEFAULT`, added for the same reason.
  //
  // `orange` must stay in step with the `orange.DEFAULT` scale (#F6A734) that
  // `text-orange` / `bg-orange` resolve to, NOT with `primary.orange`
  // (#F1A34F). Every icon here sits beside a Tailwind-classed element, so a key
  // resolving to a different hex than its class shows up as two shades of one
  // colour labelling the same thing. `color` is typed `string` and `Icon` falls
  // back to the raw value, so nothing catches a wrong key but the eye.
  //
  // No icon passes `color="orange"` today. The key stays because `text-orange`
  // is still in use, and the next orange icon needs this hex to be the right one.
  "gray-70": "#707070",
  orange: "#F6A734",
};
